import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeTrailingEventType',
    standalone: false
})
export class RemoveTrailingEventType implements PipeTransform {
  transform(inputString) {
    var result = inputString.replace('EventSourceType', '');
    return result;
  }
}
